import React, {useEffect, useState} from 'react';
import ChatBubble from "../../Rooms/components/ChatBubble/ChatBubble";
import {ConversationBlock} from '../config';

type TMessage = ConversationBlock['conversations'][number]['object'][number];

export interface ActionButton {
  text: string;
  onPress: () => void;
}

interface ConversationSequenceProps {
  data: ConversationBlock[];
  onActionButton: (button: ActionButton | null) => void;
  onComplete?: () => void;
}

const BUFFER_MS = 1200;

const ConversationSequence: React.FC<ConversationSequenceProps> = ({
  data,
  onActionButton,
  onComplete,
}) => {
  const isLarge = window.innerWidth >= 768;

  const [blockIdx, setBlockIdx] = useState(0);
  const [convIdx, setConvIdx] = useState(0);
  const [objIdx, setObjIdx] = useState(0);
  const [displayMsg, setDisplayMsg] = useState<TMessage | null>(null);
  // Changes together with displayMsg so ChatBubble remounts exactly once per message.
  const [msgKey, setMsgKey] = useState('');

  console.log(displayMsg, 'displayMsg');
  

  const advanceBlock = () => {
    onActionButton(null);
    if (blockIdx < data.length - 1) {
      setDisplayMsg(null);
      setBlockIdx(prev => prev + 1);
      setConvIdx(0);
      setObjIdx(0);
    } else {
      onComplete?.();
    }
  };

  useEffect(() => {
    const block = data[blockIdx];
    if (!block) return;

    const conversations = block.conversations;

    if (convIdx >= conversations.length) {
      const userAction = block.userActions?.find(
        a => a.component === 'block.button-input',
      );
      if (userAction) {
        onActionButton({text: userAction.buttonText, onPress: advanceBlock});
      } else {
        const timer = setTimeout(advanceBlock, 1000);
        return () => clearTimeout(timer);
      }
      return;
    }

    const currentConv = conversations[convIdx]?.object ?? [];

    if (objIdx < currentConv.length) {
      const msg = currentConv[objIdx];
      setDisplayMsg(msg);
      setMsgKey(`${blockIdx}-${convIdx}-${objIdx}`);
      const duration = parseInt(msg?.duration, 10) || 2000;
      const timer = setTimeout(() => {
        setObjIdx(prev => prev + 1);
      }, duration + BUFFER_MS);
      return () => clearTimeout(timer);
    } else {
      setObjIdx(0);
      setConvIdx(prev => prev + 1);
    }
  }, [convIdx, objIdx, blockIdx]);

  const wrapperStyle: React.CSSProperties = {
    position: 'absolute',
    right: 200,
    top: 32,
    maxWidth: 340,
    zIndex: 10,
  };

  return (
    <div style={{position: 'absolute', inset: 0, pointerEvents: 'none'}}>
      {displayMsg && (
        <div style={wrapperStyle}>
          <ChatBubble
            // Remount per message so AudioPlayer picks up the new audio
            // instead of replaying the previous one.
            key={msgKey}
            content={displayMsg.content}
            audioUri={displayMsg.audio}
          />
        </div>
      )}
    </div>
  );
};

export default ConversationSequence;
